import { TimelineLite } from 'gsap'
import { TimelineMax } from 'gsap'


export default {
    name: 'app-title',

    components: {
        TimelineLite,
        TimelineMax 
    },

    mounted() {
        var tl = new TimelineMax;
        tl.from("#line", 0.4, { scaleX: 0, transformOrigin: "right center" });
        tl.from("#upper", 0.6, { y: 13 }, "text");
        tl.from("#lower", 0.6, { y: -13 }, "text");
        tl.to("#line, #upper, #lower", 1, { opacity: 1 }, "+=3")
    },

    methods: {
        hideMenu: function(){
            this.menuOpened = false;
        },
        toggleMenu: function(){
            this.menuOpened = !this.menuOpened;
        }
    },


}